import { render, staticRenderFns } from "./FuelWithdrawalPage.vue?vue&type=template&id=654b7bca&scoped=true&"
import script from "./FuelWithdrawalPage.vue?vue&type=script&lang=js&"
export * from "./FuelWithdrawalPage.vue?vue&type=script&lang=js&"
import style0 from "./FuelWithdrawalPage.vue?vue&type=style&index=0&id=654b7bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b7bca",
  null
  
)

export default component.exports